import { useEffect } from "react";

const SITE_NAME = "Cox Capital";

function ensureMeta(selector: string, attributes: Record<string, string>): HTMLMetaElement {
	let element = document.head.querySelector<HTMLMetaElement>(selector);
	if (!element) {
		element = document.createElement("meta");
		document.head.appendChild(element);
	}
	for (const [name, value] of Object.entries(attributes)) element.setAttribute(name, value);
	return element;
}

export default function Seo({ title, description, path, noIndex = false }: { title: string; description: string; path: string; noIndex?: boolean }) {
	useEffect(() => {
		const environment = import.meta.env.VITE_APP_ENVIRONMENT;
		const isProduction = environment === "PRODUCTION";
		const shouldNoIndex = noIndex;
		const pageTitle = title === SITE_NAME ? title : `${title} | ${SITE_NAME}`;
		const pageUrl = new URL(path, isProduction ? "https://coxcapitalmtg.com" : window.location.origin).toString();
		document.title = pageTitle;
		ensureMeta('meta[name="description"]', { name: "description", content: description });
		ensureMeta('meta[name="robots"]', { name: "robots", content: isProduction && !shouldNoIndex ? "index, follow" : "noindex, nofollow, noarchive, nosnippet" });
		ensureMeta('meta[property="og:title"]', { property: "og:title", content: pageTitle });
		ensureMeta('meta[property="og:description"]', { property: "og:description", content: description });
		ensureMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
		ensureMeta('meta[property="og:url"]', { property: "og:url", content: pageUrl });
		ensureMeta('meta[property="og:site_name"]', { property: "og:site_name", content: SITE_NAME });
		ensureMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary" });

		let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
		if (isProduction && !shouldNoIndex) {
			if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
			canonical.href = pageUrl;
		} else canonical?.remove();
		document.documentElement.dataset.environment = environment === "RELEASE_CANDIDATE" ? "release-candidate" : isProduction ? "production" : "test";
	}, [description, noIndex, path, title]);

	return null;
}
